import { type IconType } from '@innovamat/glimmer-icons';
import { StateLayer } from '../../../utils/common.styled';
import { Icon } from '../../icon';
import { ButtonWrapper } from './button-circle.styles';

type ButtonCircleProps = {
  icon: IconType;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const ButtonCircle = ({ icon, className, ...rest }: ButtonCircleProps) => {
  return (
    <ButtonWrapper
      className={`${className} ripple`}
      icon={icon}
      type="button"
      {...rest}
    >
      <StateLayer className="button-stateLayer" />
      <Icon icon={icon} size="M" />
    </ButtonWrapper>
  );
};

export { ButtonCircle };
export type { ButtonCircleProps };
